import { TroubleshootComponent } from './components/troubleshoot/troubleshoot.component';
import { Component, NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AddAssessmentComponent } from './components/assessment/add-assessment/add-assessment.component';
import { AssessmentListComponent } from './components/assessment/assessment-list/assessment-list.component';
import { BusinessAssessmentComponent } from './components/assessment/business-assessment/business-assessment.component';
import { EditAssessmentComponent } from './components/assessment/edit-assessment/edit-assessment.component';
import { AccountComponent } from './components/account/account.component';
import { ForgotPasswordComponent } from './components/forgot-password/forgot-password.component';
import { SignInComponent } from './components/sign-in/sign-in.component';
import { SignUpComponent } from './components/sign-up/sign-up.component';
import { OnBoardComponent } from './components/on-board/on-board.component';
import { AddActionItemComponent } from './components/assessment-ft/action-items/add-action-item/add-action-item.component';
import { ActionItemListComponent } from './components/assessment-ft/action-items/action-item-list/action-item-list.component';
import { PaymentComponent } from './components/payment/payment.service';
import { OperatingAssessmentListComponent } from './components/assessment/operating-assessment-list/operating-assessment-list.component';
import { VerifyEmailComponent } from './components/verify-email/verify-email.component';
import { ViewsComponent } from './components/views/views.component';
import { ViewsPracticalComponent } from './components/views-practical/views-practical.component';
import {ViewsBusinessAssessmentComponent} from './components/views-business-assessment/views-business-assesment.component'
import { BusinessPlanComponent } from './components/assessment-ft/business-plan/business-plan.component';
import { ResourcesComponent } from './components/assessment-ft/resources/resources.component';
import { CalcRevenueComponent } from './components/assessment-ft/calc-revenue/calc-revenue.component';
import { AuthGuard } from './shared/guard/auth.guard';
import { EntrepDashComponent } from './components/entrep-dash/entrep-dash.component';
import { BusinessAssessmentsListComponent } from './components/assessment/business-assessments-list/business-assessments-list.component';
import { PracticalOperatingComponent } from './components/assessment/operating-assessment/operating-assessment.component';
import { SuperAdminDashboardComponent } from './components/super-admin-dashboard/super-admin-dashboard.component';
import { AdminGuardService } from './services/admin-guard/admin-guard.service';
import { AdminDetailsComponent } from './components/admin-details/admin-details.component';
import { SuperAdminComponent } from './components/super-admin/super-admin.component';

const routes: Routes = [
  { path: '', redirectTo: '/sign-in', pathMatch: 'full' },
  { path: 'sign-in', component: SignInComponent },
  { path: 'register-user', component: SignUpComponent },
  { path: 'onboard', component: OnBoardComponent, canActivate: [AuthGuard] },
  { path: 'payment-example', component: PaymentComponent },
  { path: 'account', component: AccountComponent, canActivate: [AuthGuard] },
  { path: 'forgot-password', component: ForgotPasswordComponent },
  { path: 'verify-email-address', component: VerifyEmailComponent },
 /* {
    path: 'model-assessment',
    component: AddAssessmentComponent,
    canActivate: [AuthGuard],
  },*/
  {
    path: 'model-assessments-lists',
    component: AssessmentListComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'operating-assessments-lists',
    component: OperatingAssessmentListComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'business-assessment',
    component: BusinessAssessmentComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'business-assessments-lists',
    component: BusinessAssessmentsListComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'business-assessment-results/:id',
    component: ViewsBusinessAssessmentComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'edit-assessment/:id',
    component: EditAssessmentComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'model-results/:id',
    component: ViewsComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'operating-results/:id',
    component: ViewsPracticalComponent,
    canActivate: [AuthGuard],
  },
 /* {
    path: 'operating-assessment',
    component: PracticalOperatingComponent,
    canActivate: [AuthGuard],
  },*/
  {
    path: 'business-plan',
    component: BusinessPlanComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'resources/:id',
    component: ResourcesComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'calc-revenue',
    component: CalcRevenueComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'add-action-item',
    component: AddActionItemComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'troubleshoot',
    component: TroubleshootComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'action-plan',
    component: ActionItemListComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'entrep-dash',
    component: EntrepDashComponent,
    canActivate: [AuthGuard],
  },

  {
    path: 'super-admin',
    component: SuperAdminComponent,
    children: [
      {
        path: '',
        redirectTo: 'dashboard',
        pathMatch: 'full',
      },
      {
        path: 'dashboard',
        component: SuperAdminDashboardComponent,
        canActivate: [AdminGuardService]
      },
      {
        path: 'admin-details/:admincode/:uid',
        component: AdminDetailsComponent,
      },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
